import { render } from "./oficialiaCancelados.vue?vue&type=template&id=21771faa"
import script from "./oficialiaCancelados.vue?vue&type=script&lang=js"
export * from "./oficialiaCancelados.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__